import { inject, injectable } from 'inversify';
import {
  VerificationServiceInterface,
  DefaultSendVerificationCodeParams,
  DefaultVerifyCodeParams,
  SendVerificationCodeResponse,
  VerifyCodeResponse,
} from './VerificationService.types';
import HttpClient from '../../../http';
import { backendUrl } from 'src/config';

@injectable()
class VerificationService implements VerificationServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  public sendVerificationCode({
    phoneNumber,
    env,
    sender,
    message,
    resend,
    accessToken,
  }: DefaultSendVerificationCodeParams) {
    const payload = {
      phone_number: phoneNumber,
      env,
      sender,
      message,
      resend,
    };

    return this.client
      .getClient()
      .post<SendVerificationCodeResponse>(`/users-otp/send/`, payload, {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      });
  }

  public verifyCode({
    verificationCode,
    accessToken,
    phoneNumber,
    env,
  }: DefaultVerifyCodeParams) {
    const payload = {
      otp: verificationCode,
      phone_number: phoneNumber,
      env,
    };

    return this.client
      .getClient()
      .post<VerifyCodeResponse>(`/users-otp/verify/`, payload, {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      });
  }
}

export default VerificationService;
